import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { QRCodeCanvas, QRCodeSVG } from 'qrcode.react';
import Spin from '../spin';
import Button from '../button';
import Icon from '../icon';
import devWarning from '../_utils/devwarning';
import { tuple } from '../_utils/type';
export var QRCodeTypes = tuple('canvas', 'svg');
export var QRCodeStatus = tuple('active', 'expired', 'loading');
export var QRCodeErrorLevels = tuple('L', 'M', 'Q', 'H');
var QRCode = function QRCode(props) {
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var qrCodeProps = getCompProps('QRCode', userDefaultProps, props);
  var value = qrCodeProps.value,
    size = qrCodeProps.size,
    status = qrCodeProps.status,
    style = qrCodeProps.style,
    type = qrCodeProps.type,
    errorLevel = qrCodeProps.errorLevel,
    color = qrCodeProps.color,
    onRefresh = qrCodeProps.onRefresh,
    icon = qrCodeProps.icon,
    _qrCodeProps$iconSize = qrCodeProps.iconSize,
    iconSize = _qrCodeProps$iconSize === void 0 ? 24 : _qrCodeProps$iconSize,
    bgColor = qrCodeProps.bgColor,
    _qrCodeProps$bordered = qrCodeProps.bordered,
    bordered = _qrCodeProps$bordered === void 0 ? true : _qrCodeProps$bordered;
  var className = qrCodeProps.className,
    customPrefixcls = qrCodeProps.prefixCls;
  var qrCodePrefixCls = getPrefixCls(prefixCls, 'qrcode', customPrefixcls);
  var qrCodeClass = classNames(qrCodePrefixCls, className, _defineProperty({}, "".concat(qrCodePrefixCls, "-borderless"), !bordered));
  var gap = 8;
  var containerSize = size + gap * 2 + 2;
  devWarning(!value === false, 'QRCode', 'need to receive `value` props');
  devWarning(icon && errorLevel === 'L', 'QRCode', 'ErrorLevel `L` is not recommended to be used with `icon`, for scanning result would be affected by low level.');
  var imageSettings = {
    src: icon,
    x: undefined,
    y: undefined,
    height: iconSize,
    width: iconSize,
    excavate: true
  };
  var codeProps = {
    value: value,
    size: size,
    level: errorLevel,
    fgColor: color,
    imageSettings: icon ? imageSettings : undefined
  };
  return /*#__PURE__*/React.createElement("div", {
    className: qrCodeClass,
    style: _extends(_extends({}, style), {
      width: "".concat(containerSize, "px"),
      height: "".concat(containerSize, "px"),
      backgroundColor: bgColor
    })
  }, status !== 'active' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(qrCodePrefixCls, "-mask")
  }, status === 'loading' && /*#__PURE__*/React.createElement(Spin, null), status === 'expired' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "".concat(qrCodePrefixCls, "-expired")
  }, "\u4E8C\u7EF4\u7801\u8FC7\u671F"), onRefresh && /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "refresh"
    }),
    type: "text",
    onClick: onRefresh,
    size: "middle"
  }, "\u70B9\u51FB\u5237\u65B0"))), type === 'canvas' ? /*#__PURE__*/React.createElement(QRCodeCanvas, _extends({}, codeProps)) : /*#__PURE__*/React.createElement(QRCodeSVG, _extends({}, codeProps)));
};
QRCode.displayName = 'QRCode';
export default QRCode;